<template>
  <div class="grid p-fluid">
    <div class="col-12 md:col-4">
      <div class="card">
       
        <div class="card-body">
          <div class="profile-container d-flex flex-column align-items-center text-center">
            <!-- Profile Image -->
            <img style="width: 200px; height: 200px; border-radius: 50%;" class="profile-image" :src="profile_photo
              ? profile_photo
              : 'https://hoarding-eticket-docs.s3.ap-south-1.amazonaws.com/Profile/undefined/senior%20clerk%20user/Thumbnail_2024_08_05_14_49_44.png'
              " />
            <!-- Spacing between the image and button -->
            <div class="image-button-container mt-3">
              <!-- Upload Image Button -->
              <Button v-if="isEditing"
                style="box-shadow: 0 2px 6px rgba(0, 176, 176, 0.549); border-color: #00b0b0; background-color: #00b0b0;"
                label="Upload Image" @click="toggleShow" icon="pi pi-upload" class="p-button-upload" />
            </div>
            <!-- Upload Image Modal (My-Upload Component) -->
            <my-upload field="img" @crop-success="cropSuccess" langType="en" v-model="show_image" :width="width"
              :height="height" :url="url" :params="params" :headers="headers" img-format="png" :noCircle="true"
              :noRotate="false" />
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-8">
      <div class="card">
     
    
      
        <div class="col-12 md:col-11">
          <div class="profile-card card">
            <div class="card-header">
              <h2><b>Profile Details</b></h2>
              <Button icon="pi pi-pencil" class="p-button-rounded p-button-warning edit-btn" @click="edit()" />
            </div>
            <div class="card-body">
              <div class="p-fluid formgrid grid">
                <div class="field-label field col-12 md:col-4">
                  <h6 class="mb-0">Full Name</h6>
                </div>
                <div class="field col-12 md:col-6">
                  <p v-if="disabled">{{ full_name }}</p>
                  <InputText v-else type="text" @keypress="validateUserName($event)" v-model="full_name"
                    class="input-text" />
                </div>
              </div>
              <hr />
              <div class="p-fluid formgrid grid">
                <div class="field-label field col-12 md:col-4">
                  <h6 class="mb-0">Mobile</h6>
                </div>
                <div class="field col-12 md:col-6">
                  <p v-if="disabled">{{ mobile }}</p>
                  <InputText v-else type="text" maxlength="10" @keypress="allowOnlyDigits" v-model="mobile"
                    class="input-text" />
                </div>
              </div>
              <hr />
              <div class="p-fluid formgrid grid">
                <div class="field-label field col-12 md:col-4">
                  <h6 class="mb-0">Email</h6>
                </div>
                <div class="field col-12 md:col-6">
                  <p v-if="disabled">{{ email }}</p>
                  <InputText v-else type="text" v-model="email" class="input-text" />
                </div>
              </div>
              <hr />
              <div class="p-fluid formgrid grid">
                <div class="field-label field col-12 md:col-4">
                  <h6 class="mb-0">Address</h6>
                </div>
                <div class="field col-12 md:col-6">
                  <p v-if="disabled">{{ address }}</p>
                  <InputText v-else type="text" v-model="address" class="input-text" />
                </div>
              </div>
              <hr />
              <div class="p-fluid formgrid grid">
                <div class="field-label field col-12 md:col-4">
                  <h6 class="mb-0">Pincode</h6>
                </div>
                <div class="field col-12 md:col-6">
                  <p v-if="disabled">{{ pincode }}</p>
                  <InputText v-else type="text" maxlength="6" v-model="pincode" class="input-text" />
                </div>
              </div>
              <hr />

              <div class="p-fluid formgrid grid">
                <div class="field-label field col-12 md:col-4"></div>
                <div class="field-label field col-12 md:col-2">
                  <Button  v-if="isEditing" class="p-button-success " @click="Save_Details()" v-tooltip.bottom="'Save'" >Save</Button> 
                              
                </div>
                <div class="field-label field col-12 md:col-2">
                  <Button v-if="isEditing"  @click="reset()" style="background-color:  #E43444;" v-tooltip.bottom="'Cancel'" >Cancel</Button>
                </div>
               
              </div>


             
          </div>
          <!-- <div class="col-12 md:col-6"  style="display: flex; justify-content: center; gap: 10px; margin-top: 20px;">
                <Button v-if="isEditing" label="save" style="background-color: #34E49C;   margin-left: 50%;" @click="Save_Details()" icon="pi pi-check"
                      class="p-button mr-1 mb-1 " /> 
                <Button v-if="isEditing" style="background-color:  #E43444; margin-left: 50%" label=" Cancel" icon="pi pi-times"
                  class="p-button mr-1 mb-1" @click="reset" />
              </div> -->
              
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import apis from '@/apis';
import axios from "axios";
import Swal from 'sweetalert2';
import myUpload from "vue-image-crop-upload";
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  customClass: "swwtal",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  }
});
export default {
  data() {
    return {
      profile_photo: '',
      disabled: true,
      isEditing: false,
      show_image: false,
      full_name: '',
      email: '',
      params: {
        token: "123456798",
        name: "avatar",
      },
      headers: {
        smail: "*_~",
      },
      imgDataUrl: "",
      Image_data: {
        filePath: "",
        contentType: "",
      },
      url: "",
      pincode: '',
      address: '',
      mobile: '',
      width: 250,
      height: 300,
      profile_image: '',
      data: [],
      id: '',
    };
  },
  methods: {
    // reset()
    //   {
    //     this.isEditing = false;
    //   },
    reset() {
      this.id = parseInt(localStorage.getItem("id")),
        this.full_name = localStorage.getItem('full_name');
      this.mobile = localStorage.getItem('mobile');
      this.pincode = localStorage.getItem('pincode');
      this.address = localStorage.getItem('address')
      this.email = localStorage.getItem('email');
      this.profile_photo = localStorage.getItem('profile_photo');
      this.disabled = true;
      this.isEditing = false;
    },
    validateUserName(event) {
      const charCode = event.charCode || event.keyCode;
      // Only allow alphabets (uppercase, lowercase) and space
      if (
        !(charCode >= 65 && charCode <= 90) &&  // A-Z
        !(charCode >= 97 && charCode <= 122) && // a-z
        charCode !== 32                         // space
      ) {
        event.preventDefault();
      }
    },
    allowOnlyDigits(event) {
      // Allow only digit characters
      if (event.charCode < 48 || event.charCode > 57) {
        event.preventDefault();
      }
    },
    async edit() {
      this.isEditing = true;
      this.disabled = false;
    },
    toggleShow() {
      this.show_image = !this.show_image;
    },
    async cropSuccess(imgDataUrl) {
      this.imgDataUrl = imgDataUrl;
      var substrings = imgDataUrl.split(";");
      var contentType = substrings[0].split(":");
      var type = imgDataUrl.split(";")[0].split("/")[1];
      this.handleFileUpload_thumb_with_cropper(imgDataUrl, type, contentType[0]);
    },
    async generateString() {
      // Get the current date and time
      const currentDateTime = new Date();
      // Format the date as YYYY_MM_DD
      const formattedDate = currentDateTime.toISOString().split('T')[0].replace(/-/g, '_');
      // Format the time as HH_mm_ss
      const formattedTime = currentDateTime.toTimeString().split(' ')[0].replace(/:/g, '_');
      // Construct the final string
      const resultString = `${formattedDate}_${formattedTime}`;
      return resultString;
    },
    async handleFileChange(base64, content_Type, filename) {
      const base64String = base64;
      const contentType = content_Type;
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: contentType });
      const fileName = filename;
      var file = new File([blob], fileName, { type: contentType });
      return file;
    },
    async handleFileUpload_thumb_with_cropper(imgDataUrl, type, contentType) {
      var prfeix = await this.generateString();
      var filename = prfeix + "." + type;
      var subimgDataUrl = imgDataUrl.split(",");
      var file = await this.handleFileChange(
        subimgDataUrl[1],
        contentType,
        filename
      );
      this.Image_data = {
        filePath: "",
        contentType: "",
      };
      this.Image_data = {
        filePath:
          "profile_image/" +
          filename,
        contentType: contentType,
      };
      this.isLoadingModel = true;
      var promise = apis.upload_to_AWS(this.Image_data);
      promise.then((response) => {
        axios
          .put(response.data.data, file, {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": contentType,
            },
          })
          .then((response) => {
            this.isLoadingModel = false;
            this.profile_photo = encodeURI("https://hoarding-eticket-docs.s3.ap-south-1.amazonaws.com/" + this.Image_data.filePath);
            // this.$toast.add({
            // severity: "success",
            // summary: "success",
            // detail: "Upload Successfully",
            // life: 3000,
            // });
            // return false;
          });
      });
    },
    onImageChange(event) {
      const file = event.target.files[0];
      if (file && file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.profile_image = e.target.result; // Update the image preview
        };
        reader.readAsDataURL(file); // Convert the file to base64 string
      } else {
        Toast.fire({
          icon: 'error',
          title: 'Please upload a valid image file'
        });
      }
    },
    async Save_Details() {
      //  alert(99);
     
      var first_name_pattern = /^[a-zA-Z\s]+$/;
      if (this.full_name == "" || (this.full_name && (!first_name_pattern.test(this.full_name || this.full_name.length > 100)))) {
        Toast.fire({
          icon: 'error',
          title: 'Please Enter a valid Name (only alphabets and spaces).',
          target: document.getElementById("#exampleFormControlSelect1")
        });
        return false;
      }
      if (this.email == '' || this.email == null || this.email == undefined) {
        Toast.fire({
          icon: 'error',
          title: 'Please Enter Email ID'
        });
        return false;
      }
      const emailPattern = /^[a-z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,}$/;
      if (!emailPattern.test(this.email)) {
        Toast.fire({
          icon: 'error',
          title: 'Please Enter a Valid Email ID'
        });
        return false;
      }
      if (this.mobile == '' || this.mobile == null || this.mobile == undefined) {
        //alert("Please Enter Username");
        Toast.fire({
          icon: 'error',
          title: 'Please Enter MobileNumber'
        });
        return false;
      }
      if (!this.mobile || this.mobile.length !== 10) {
        Toast.fire({
          icon: 'error',
          title: 'Please Enter a 10-digit Mobile Number'
        });
        return false;
      }
      if (!/^\d+$/.test(this.mobile)) {
        Toast.fire({
          icon: 'error',
          title: 'Mobile Number should contain only digits'
        });
        return false;
      }
      if (/^0+$/.test(this.mobile) || /^0/.test(this.mobile)) {
        Toast.fire({
          icon: 'error',
          title: 'Please Enter a Valid Mobile Number'
        });
        return false;
      }
      if (!this.pincode) {
        Toast.fire({
          icon: 'error',
          title: 'Please Enter Pincode'
        });
        return false;
      }
      const pincodePattern = /^[1-9][0-9]{5}$/; // Matches a 6-digit number starting from 1-9
      if (!pincodePattern.test(this.pincode)) {
        Toast.fire({
          icon: 'error',
          title: 'Please Enter a Valid Pincode (6 digits)'
        });
        return false;
      }
      const pincodeValue = parseInt(this.pincode, 10);
      if (pincodeValue < 400001 || pincodeValue > 499999) {
        Toast.fire({
          icon: 'error',
          title: 'Pincode must be between 400001 and 499999'
        });
        return false;
      }

      const confirmUpdate = await Swal.fire({
        title: 'Are you sure?',
        text: "You are about to update your profile.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, update it!',
        cancelButtonText: 'No, cancel!',
      });
      if (!confirmUpdate.isConfirmed) {
        return; // Exit if user cancels
      }
      //////////////////////////////////////
      if (this.Image_data.filePath != "") {
        var poster = encodeURI("https://hoarding-eticket-docs.s3.ap-south-1.amazonaws.com/" + this.Image_data.filePath);
      }
      else
        var poster = this.profile_image
      let profileDetails = {
        ID: this.id,
        NAME: this.full_name,
        ADDRESS: this.address,
        MOBILE: this.mobile,
        EMAIL: this.email,
        PINCODE: this.pincode,
        PROFILE_PHOTO: poster,
        UPDATED_BY: this.id
      };
      this.loading = true;
      apis.ProfileEdit(profileDetails)
        .then((response) => {
          this.loading = false;
          if (response.data.status == true) {
            localStorage.setItem("profile_photo", poster);
            localStorage.setItem("email", this.email);
            localStorage.setItem("full_name",this.full_name);
            localStorage.setItem("address",this.address);
            localStorage.setItem("mobile",this.mobile);
            localStorage.setItem("pincode",this.pincode);

            this.profile_photo=poster;
            Toast.fire({
              icon: 'success',
              title: response.data.message
            });
            // this.GetUserDetailsByID(); 
          
            this.disabled = true;
            this.isEditing = false;
          } else {
            Toast.fire({
              icon: 'error',
              title: response.data.message
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("Error updating profile:", error.message);
          Toast.fire({
            icon: 'error',
            title: 'Error updating profile'
          });
        });
    }
  },
  async created() {
    this.data = await JSON.parse(localStorage.getItem("user_profile"));
    // this.id = localStorage.getItem('id');
    this.id = parseInt(localStorage.getItem("id")),
      this.full_name = localStorage.getItem('full_name');
    this.mobile = localStorage.getItem('mobile');
    this.pincode = localStorage.getItem('pincode');
    this.address = localStorage.getItem('address')
    this.email = localStorage.getItem('email');
    this.profile_photo = localStorage.getItem('profile_photo');
    // alert(this.full_name);
    // alert(this.email );
    // alert(this.mobile );
    // alert(this.id);
  },
  components: { "my-upload": myUpload },
};
</script>
<style>
/* Profile Container Styling */
.profile-container {
  padding: 2rem;
  background-color: #f9f9f9;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  transition: all 0.3s ease;
  margin-bottom: 2rem;
}

/* Profile Image Styling */
.profile-image {
  border: 5px solid #00b0b0;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  object-fit: cover;
  transition: transform 0.3s ease;
}

.profile-image:hover {
  transform: scale(1.05);
}

/* Upload Button Container */
.image-button-container {
  margin-top: 20px;
}

/* Upload Button Styling */
.p-button-upload {
  background-color: #00b0b0 !important;
  border-color: #00b0b0 !important;
  color: white;
  font-size: 1rem;
  padding: 0.5rem 1.5rem;
  border-radius: 10px;
  transition: background-color 0.3s ease;
}

.p-button-upload:hover {
  background-color: #008a8a !important;
  border-color: #008a8a !important;
}

/* Adjustments for My-Upload Modal */
.my-upload {
  margin-top: 1rem;
  width: 100%;
}

.profile-card {
  background: #fff;
  border-radius: 15px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  margin-bottom: 2rem;
  transition: all 0.3s ease;
}

.profile-card:hover {
  box-shadow: 0px 6px 25px rgba(0, 0, 0, 0.15);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}

.card-header h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
}

.edit-btn {
  background-color: #FF9800;
  border: none;
  color: white;
  font-size: 1.2rem;
  transition: background-color 0.3s ease;
}

.edit-btn:hover {
  background-color: #e68900;
}

.field-label h6 {
  color: #555;
  font-size: 1rem;
}

.input-text {
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 0.75rem;
  font-size: 1rem;
  transition: border-color 0.3s ease;
  width: 100%;
}

.input-text:focus {
  border-color: #FF9800;
  outline: none;
  box-shadow: 0 0 5px rgba(255, 152, 0, 0.5);
}

hr {
  border: 0;
  height: 1px;
  background: #eee;
  margin: 1rem 0;
}

.save-btn {
  background-color: #4CAF50;
  border: none;
  color: white;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  transition: background-color 0.3s ease;
}

.save-btn:hover {
  background-color: #45a049;
}

body {
  margin-top: 20px;
  color: #1a202c;
  text-align: left;
  background-color: #e2e8f0;
}

.main-body {
  padding: 15px;
}

.card {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 0 solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1rem;
}

.gutters-sm {
  margin-right: -8px;
  margin-left: -8px;
}

.gutters-sm>.col,
.gutters-sm>[class*="col-"] {
  padding-right: 8px;
  padding-left: 8px;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.bg-gray-300 {
  background-color: #e2e8f0;
}

.h-100 {
  height: 100% !important;
}

.shadow-none {
  box-shadow: none !important;
}
</style>
